<div style="display: flex;">
  <img src="../../../assets/warning.svg" style="width: 60px; position: absolute;">
  <h1 mat-dialog-title style="margin-left: auto; margin-right: auto;">{{data.title}}</h1>
</div>
<div mat-dialog-content class="modal-body modal-content">
  <p [innerHTML]="data.message['flowRate']"></p>
  <span [innerHTML]="data.message['solutions']"></span>
  <ul>
    <li [innerHTML]="data.message['nominalCapSolution']"></li>
    <li [innerHTML]="data.message['feedstockSolution']"></li>
    <li *ngIf="data.message['biogasShareSolution']" [innerHTML]="data.message['biogasShareSolution']"></li>
  </ul>
</div>
<div mat-dialog-actions class="modal-buttons">
  <button type="button" mat-raised-button class="mat-raised-button" (click)="confirm()">confirm</button>
</div>
